module.exports = __webpack_public_path__ + "static/media/logo2.ce80cfa7.png";